/* eslint-disable no-console */
export default class Swatches {
  constructor() {
    this.state = {
      activeSwatch: {
        element: '',
        code: '',
        description: '',
        img: '',
        name: '',
        statusMessage: '',
      },
      activeCollection: {
        element: '',
        id: '',
        subnav: false,
        tab: '',
      },
      activeSubCollection: {
        element: '',
        id: '',
        tab: '',
      },
      selectedSwatches: {
        defaultSwatchSelected: false,
        limit: 0,
        list: [],
        warning: '',
      },
    };

    this.getSwatchData = element => (
      {
        element,
        code: element.getAttribute('data-colorcode'),
        description: element.getAttribute('data-description'),
        img: element.getAttribute('data-detailimg'),
        name: element.getAttribute('data-colorname'),
        statusMessage: element.getAttribute('data-statusmessage'),
      }
    );

    this.getActiveTabFromId = (id, collectionBtns) => {
      for (let i = 0; i < collectionBtns.length; i++) { /* eslint-disable-line no-plusplus */
        const btn = collectionBtns[i];
        const contentId = btn.getAttribute('aria-controls');
        if (contentId === id) {
          return btn;
        }
      }
      return null;
    };
    // Event handlers for all buttons on swatches page
    const swatchSelector = '.fabric-swatches .swatch-details-btn';
    const collectionBtns = document.querySelectorAll('.fabric-collection-nav button');
    const collectionDropdown = document.getElementById('AwningFabric');
    const subCollectionDropdown = document.getElementById('FabricSubCollection');
    const swatchBtns = document.querySelectorAll(swatchSelector);
    const checkboxes = document.querySelectorAll('.fabric-swatches .swatch-checkbox input');
    const prevBtns = document.querySelectorAll('.button-previous');
    const nextBtns = document.querySelectorAll('.button-next');
    // Event handler for collections (main/sub-collections)
    [].map.call(collectionBtns, btn => (
      btn.addEventListener('click', () => {
        let data = {};
        const id = btn.getAttribute('aria-controls');
        // Check whether button is in main nav, and contains a subnav
        const hasSubnav = btn.getAttribute('data-subnav');
        // Check whether button is in main nav/subnav
        const isSubnav = btn.classList.contains('button-subnav');
        if (isSubnav) {
          data = {
            activeSubCollection: {
              element: document.getElementById(id),
              id,
              tab: btn,
            },
          };
        } else if (hasSubnav) {
          // Get first subnav collection tab
          // Set tab to active
          // Display first tab's panel
          const subnavBtnList = document.querySelectorAll(`#${hasSubnav} button`);
          let subnavBtn1 = null;
          let subnavBtn1PanelId = '';
          let subnavBtn1Panel = null;
          for (let i = 0; i < subnavBtnList.length; i++) { /* eslint-disable-line no-plusplus */
            const subnavBtn = subnavBtnList[i];
            if (i === 0) {
              subnavBtn1 = subnavBtn;
              subnavBtn1.setAttribute('aria-selected', true);
              subnavBtn1PanelId = subnavBtn.getAttribute('aria-controls');
              subnavBtn1Panel = document.getElementById(subnavBtn1PanelId);
              subnavBtn1Panel.removeAttribute('hidden');
            } else {
              subnavBtn.setAttribute('aria-selected', false);
            }
          }
          data = {
            activeCollection: {
              element: document.getElementById(id),
              id,
              subnav: true,
              tab: btn,
            },
            activeSubCollection: {
              element: subnavBtn1Panel,
              id: subnavBtn1PanelId,
              tab: subnavBtn1,
            },
          };
        } else {
          data = {
            activeCollection: {
              element: document.getElementById(id),
              id,
              subnav: false,
              tab: btn,
            },
            activeSubCollection: {
              element: '',
              id: '',
              tab: '',
            },
          };
        }
        this.setState(data);
        this.updateCollection();
        this.updateCollectionDropdown(collectionDropdown);
        this.updateSubnavContent();
      })
    ));
    // Event handler for responsive main collection nav
    if (collectionDropdown) {
      collectionDropdown.addEventListener('change', (event) => {
        let data = {};
        const id = `panel-${event.target.value}`;
        const tab = this.getActiveTabFromId(id, collectionBtns);
        const hasSubnav = tab.getAttribute('data-subnav');
        let subnavBtn1 = null;
        let subnavBtn1PanelId = '';
        let subnavBtn1Panel = null;
        if (hasSubnav) {
          // Get first subnav collection tab
          // Set tab to active
          // Display first tab's panel
          const subnavBtnList = document.querySelectorAll(`#${hasSubnav} button`);
          for (let i = 0; i < subnavBtnList.length; i++) { /* eslint-disable-line no-plusplus */
            const subnavBtn = subnavBtnList[i];
            if (i === 0) {
              subnavBtn1 = subnavBtn;
              subnavBtn1.setAttribute('aria-selected', true);
              subnavBtn1PanelId = subnavBtn.getAttribute('aria-controls');
              subnavBtn1Panel = document.getElementById(subnavBtn1PanelId);
            } else {
              subnavBtn.setAttribute('aria-selected', false);
            }
          }
          data = {
            activeCollection: {
              element: document.getElementById(id),
              id,
              subnav: true,
              tab,
            },
            activeSubCollection: {
              element: subnavBtn1Panel,
              id: subnavBtn1PanelId,
              tab: subnavBtn1,
            },
          };
        } else {
          data = {
            activeCollection: {
              element: document.getElementById(id),
              id,
              subnav: false,
              tab,
            },
          };
        }
        this.setState(data);
        this.updateCollection();
        this.updateCollectionTabs(collectionBtns);
        this.updateSubnavContent();
        // Must be done AFTER updateCollectionTabs()
        if (subnavBtn1Panel) {
          subnavBtn1Panel.removeAttribute('hidden');
        }
      });
    }
    // Event handler for responsive sub-collection nav
    if (subCollectionDropdown) {
      subCollectionDropdown.addEventListener('change', (event) => {
        const id = `panel-${event.target.value}`;
        const data = {
          activeSubCollection: {
            element: document.getElementById(id),
            id,
            tab: this.getActiveTabFromId(id, collectionBtns),
          },
        };
        this.setState(data);
        this.updateCollection();
        this.updateSubCollectionTabs(collectionBtns);
        this.updateSubnavContent();
      });
    }
    // Event handler for swatches
    [].map.call(swatchBtns, btn => (
      btn.addEventListener('click', () => {
        const data = {
          activeSwatch: this.getSwatchData(btn),
        };
        this.setState(data);
        this.updateSwatch();
      })
    ));
    // Event handler for selection checkboxes (may not exist in all instances of swatches)
    [].map.call(checkboxes, input => (
      input.addEventListener('click', () => {
        const state = this.getState();
        const { selectedSwatches } = state;
        const { limit, list, warning } = selectedSwatches;
        // If limit is greater than 1, and user is over limit w/ selected swatch,
        // deselect swatch and display alert
        if (limit > 1 && list.length >= limit && input.checked) {
          window.alert(warning);
          input.checked = false;
          return;
        }
        if (limit === 1) {
          // If limit is 1, deselect any swatch across all collections
          const inputList = document.querySelectorAll('.swatch-details-btn input');
          for (let i = 0; i < inputList.length; i++) { /* eslint-disable-line no-plusplus */
            if (input !== inputList[i]) {
              inputList[i].checked = false;
            } else {
              inputList[i].checked = true;
            }
          }
        }
        const data = {
          selectedSwatches: {
            list: this.manageSelectedSwatches(input.value),
          },
        };
        this.setState(data);
      })
    ));
    // Event handler for previous buttons
    [].map.call(prevBtns, btn => (
      btn.addEventListener('click', () => {
        const swatch = this.getPreviousSwatchInDom();
        const data = {
          activeSwatch: this.getSwatchData(swatch),
        };
        this.setState(data);
        this.updateSwatch();
      })
    ));
    // Event handler for next buttons
    [].map.call(nextBtns, btn => (
      btn.addEventListener('click', () => {
        const swatch = this.getNextSwatchInDom();
        const data = {
          activeSwatch: this.getSwatchData(swatch),
        };
        this.setState(data);
        this.updateSwatch();
      })
    ));
  }

  init(options) {
    const {
      defaultSwatchSelected,
      maxSelections,
      selectedCollection,
      warning,
    } = options;
    // Configure for selectedCollection if not empty, or default to first nav item
    const collectionBtns = document.querySelectorAll('.fabric-collection-nav button');
    const data = {};
    if (collectionBtns.length > 0) {
      let btn = collectionBtns[0];
      if (selectedCollection !== '') {
        btn = document.getElementById(`tab-${selectedCollection}`);
      }
      const id = btn.getAttribute('aria-controls');
      data.activeCollection = {
        element: document.getElementById(id),
        id,
      };
    } else {
      // Assume "active" collection is the selectedCollection
      data.activeCollection = {
        element: document.getElementById(`panel-${selectedCollection}`),
        selectedCollection,
      };
    }
    // Configure for ability to "select" swatches if maxSelections is not null or greater than 0
    const limit = maxSelections !== undefined ? maxSelections : 0;
    data.selectedSwatches = {
      defaultSwatchSelected,
      limit,
      warning,
    };
    this.setState(data);
    this.updateCollection();
  }

  setState(data) {
    Object.keys(data).forEach((key1) => {
      if (typeof data[key1] !== 'object') {
        this.state[key1] = data[key1];
      } else {
        Object.keys(data[key1]).forEach((key2) => {
          this.state[key1][key2] = data[key1][key2];
        });
      }
    });
  }

  getState() {
    return this.state;
  }

  getActiveSubCollectionDiv() {
    const state = this.getState();
    const { activeSubCollection } = state;
    const { element } = activeSubCollection;
    return element;
  }

  getActiveCollectionDiv() {
    const state = this.getState();
    const { activeCollection } = state;
    const { element, subnav } = activeCollection;
    if (subnav) {
      return this.getActiveSubCollectionDiv();
    }
    return element;
  }

  getFirstSwatchInDom() {
    const state = this.getState();
    const { activeCollection, activeSubCollection } = state;
    const getSwatch = (collection) => {
      const { element } = collection;
      const swatchList = element.querySelectorAll('.swatch-details-btn:not(.hidden)');
      if (swatchList.length > 0) {
        return swatchList[0];
      }
      return null;
    };
    let swatch = getSwatch(activeCollection);
    if (swatch) {
      return swatch;
    }
    swatch = getSwatch(activeSubCollection);
    if (swatch) {
      return swatch;
    }
    return null;
  }

  getPreviousSwatchInDom() {
    const state = this.getState();
    const { activeSwatch } = state;
    const { element } = activeSwatch;
    const collection = this.getActiveCollectionDiv();
    const swatchBtns = collection.querySelectorAll('.swatch-details-btn:not(.hidden)');
    let at = 0;
    for (let i = 0; i < swatchBtns.length; i++) { /* eslint-disable-line no-plusplus */
      if (swatchBtns[i] === element) {
        at = i - 1;
      }
    }
    if (at < 0) {
      at = swatchBtns.length - 1;
    }
    return swatchBtns[at];
  }

  getNextSwatchInDom() {
    const state = this.getState();
    const { activeSwatch } = state;
    const { element } = activeSwatch;
    const collection = this.getActiveCollectionDiv();
    const swatchBtns = collection.querySelectorAll('.swatch-details-btn:not(.hidden)');
    let at = 0;
    for (let i = 0; i < swatchBtns.length; i++) { /* eslint-disable-line no-plusplus */
      if (swatchBtns[i] === element) {
        at = i + 1;
      }
    }
    if (at >= swatchBtns.length) {
      at = 0;
    }
    return swatchBtns[at];
  }

  updateSwatch() {
    const state = this.getState();
    const { activeSubCollection, activeSwatch } = state;
    const { id } = activeSubCollection;
    const {
      description,
      element,
      img,
      name,
      statusMessage,
    } = activeSwatch;
    // Update "active collection" to whatever the selected swatch is w/in (build awning fix)
    const collection = element.closest('.container').parentNode;
    // Check to see if activeSubCollection has an id
    // if so, update activeSubCollection instead
    let data = {
      activeCollection: {
        element: collection,
        id: collection.id,
      },
    };
    if (id !== '') {
      data = {
        activeSubCollection: {
          element: collection,
          id: collection.id,
        },
      };
    }
    this.setState(data);
    const swatchCards = collection.querySelectorAll('.swatch-details-btn');
    [].map.call(swatchCards, (card) => {
      card.classList.remove('selected');
    });
    element.classList.add('selected');
    // Detail image
    const detailImg = collection.querySelector('.product-swatch-detail img');
    if (detailImg !== null) {
      detailImg.src = img;
      detailImg.alt = `Detail of ${name} swatch texture and in-use photo product`;
    }
    // Swatch label
    const labelWrapper = collection.querySelector('.selected-swatch-name');
    if (labelWrapper !== null) {
      labelWrapper.textContent = name;
    }
    // Swatch description
    const descWrapper = collection.querySelector('.selected-swatch-description');
    if (descWrapper !== null) {
      descWrapper.textContent = description;
    }
    // Swatch status
    const statusWrapper = collection.querySelector('.selected-swatch-status-message');
    if (statusWrapper === null) {
      return;
    }
    if (statusMessage) {
      statusWrapper.innerHTML = `<p>${statusMessage}</p>`;
      statusWrapper.classList.remove('hidden');
    } else {
      statusWrapper.classList.add('hidden');
    }
  }

  updateCollection() {
    const swatch = this.getFirstSwatchInDom();
    if (swatch !== null) {
      this.setState({
        activeSwatch: this.getSwatchData(swatch),
      });
      this.updateSwatch();
    }
  }

  manageSelectedSwatches(id) {
    const state = this.getState();
    const { selectedSwatches } = state;
    const { list } = selectedSwatches;
    const isSelected = list.find(item => item === id);
    if (isSelected) {
      return list.filter(item => item !== id);
    }
    const arr = [...list];
    arr.push(id);
    return arr;
  }

  getSelectedSwatches() {
    const state = this.getState();
    const { selectedSwatches } = state;
    const { list } = selectedSwatches;
    return list;
  }

  updateCollectionTabs(collectionBtns) {
    const state = this.getState();
    const { activeCollection } = state;
    const { id } = activeCollection;
    for (let i = 0; i < collectionBtns.length; i++) { /* eslint-disable-line no-plusplus */
      const btn = collectionBtns[i];
      const contentId = btn.getAttribute('aria-controls');
      if (contentId === id) {
        // Set this tab as selected
        btn.setAttribute('aria-selected', true);
        // Show the selected panel
        document.getElementById(btn.getAttribute('aria-controls')).removeAttribute('hidden');
      } else {
        // Remove all current selected tabs
        btn.setAttribute('aria-selected', false);
        // Hide all tab panels
        document.getElementById(btn.getAttribute('aria-controls')).setAttribute('hidden', true);
      }
    }
  }

  updateSubCollectionTabs(collectionBtns) {
    const state = this.getState();
    const { activeSubCollection } = state;
    const { id } = activeSubCollection;
    for (let i = 0; i < collectionBtns.length; i++) { /* eslint-disable-line no-plusplus */
      const btn = collectionBtns[i];
      const contentId = btn.getAttribute('aria-controls');
      if (contentId === id) {
        // Set this tab as selected
        btn.setAttribute('aria-selected', true);
        // Show the selected panel
        document.getElementById(btn.getAttribute('aria-controls')).removeAttribute('hidden');
      } else {
        // Remove all current selected tabs
        btn.setAttribute('aria-selected', false);
        // Hide all tab panels
        document.getElementById(btn.getAttribute('aria-controls')).setAttribute('hidden', true);
      }
    }
  }

  updateCollectionDropdown(collectionDropdown) {
    const state = this.getState();
    const { activeCollection } = state;
    const { id } = activeCollection;
    collectionDropdown.value = id.substring(id.indexOf('-') + 1);
  }

  updateSubnavContent() {
    const state = this.getState();
    const { activeCollection } = state;
    const { tab } = activeCollection;
    // Hide any visible subnavs or panels related to subnavs
    const collectionSubnavs = document.querySelectorAll('.tab-subnav');
    [].map.call(collectionSubnavs, (subnav) => {
      subnav.setAttribute('hidden', 'hidden');
    });
    const selectedPanel = document.getElementById(tab.getAttribute('aria-controls'));
    const isSubnav = tab.getAttribute('data-subnav');
    if (isSubnav) {
      // Hide main collection category panel
      selectedPanel.setAttribute('hidden', 'hidden');
      // Show related subnav
      const activeSubnav = document.getElementById(isSubnav);
      activeSubnav.removeAttribute('hidden');
    } else {
      // Hide any panels associated with subnavs
      [].map.call(collectionSubnavs, (subnav) => {
        const subnavBtns = subnav.querySelectorAll('button');
        [].map.call(subnavBtns, (btn) => {
          const subnavPanel = document.getElementById(btn.getAttribute('aria-controls'));
          subnavPanel.setAttribute('hidden', 'hidden');
        });
      });
    }
  }
}
window.Swatches = Swatches;
/* eslint-enable no-console */
